import { Checkbox, Typography } from 'seagull';
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManualPaymentApprovalCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const onClick = () => onOpenModal({
    width: '500px',
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Manual approval of each payment',
        testid: "edit-manual-payment-approval-modal-".concat(index),
        content: /*#__PURE__*/_jsx(Checkbox, {
          "data-testid": "edit-manual-payment-approval-checkbox-".concat(index),
          checked: draft.allowManualPayments(),
          onChange: () => setDraft(draft.setAllowManualPayments(!draft.allowManualPayments())),
          children: /*#__PURE__*/_jsx(Typography, {
            skin: "standard",
            children: "Let my client manually approve each payment"
          })
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-manual-payment-approval-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "manual-payment-approval-".concat(index),
      children: draft.allowManualPayments() ? 'Yes' : 'No'
    })
  });
}